import type { usePopover } from 'minimal-shared/hooks';

import { Box, Button, Tooltip, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  isTenantInvoice?: boolean;
  handlePayNowButton?: (row: any) => void;
  /** When set, Pay Now is disabled and this text explains why. */
  lockedMessage?: string;
  menuActions: ReturnType<typeof usePopover>;
  openinvoiceUtils: (event: React.MouseEvent<HTMLElement>, row: any) => void;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellInvoiceUtils({
  row,
  isTenantInvoice,
  handlePayNowButton,
  lockedMessage = '',
  menuActions,
  openinvoiceUtils,
  t,
}: Props) {
  const isPaid = 'status' in row && row.status === 'paid';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {!isTenantInvoice && (
        // Disabled buttons swallow hover events, so the tooltip sits on a wrapper.
        <Tooltip title={!isPaid ? lockedMessage : ''}>
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handlePayNowButton?.(row)}
              disabled={isPaid || !!lockedMessage}
              sx={{
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                },
              }}
            >
              {t('PAY_NOW')}
            </Button>
          </span>
        </Tooltip>
      )}
      <IconButton
        color={menuActions.open ? 'inherit' : 'default'}
        onClick={(e) => openinvoiceUtils(e, row)}
        sx={{
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'scale(1.1)',
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>
    </Box>
  );
}
